





















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
@Component({
  components: {}
})
export default class channelAttrSelect extends Vue {
  // @InjectReactive("channelLocale") channelLocale;
  // 0：单选；1：多选；2：输入框；3：数字；4：富文本；5：日期；6：对象；7：单选可输入；8：多选可输入，9：其他
  @Prop({ default: () => [] }) list; // 属性结构数据对象
  @Prop({ default: () => "" }) dataValue; // 需要回显的值
  @Prop({ default: false }) multiple; // 是否多选
  @Prop({ default: false }) allowCreate; // 是否允许新建
  @Prop({ default: false }) disabled; // 输入框是否仅为显示
  curValue: any = "";
  @Watch("dataValue", { immediate: true })
  watchDataValue(val) {
    this.curValue = val;
  }
  @Watch("curValue", { deep: true })
  watchCurValue(val) {
    this.$emit("update:dataValue", val);
  }
  displayText = "-";
  mounted() {
    if (this.disabled && this.curValue) {
      this.$nextTick(function() {
        this.getPresentText();
      });
    }
  }
  async getPresentText() {
    if (!this.multiple) {
      let node = this.list.filter(
        _ => _.channelAttrValueCode === this.curValue
      );
      if (node && node.length > 0) {
        this.displayText = node[0].channelAttrValueName;
      }
    } else {
      let list = (this as any).$refs.channelSelect.selected;
      if (list && list.length > 0) {
        this.displayText = list.map(_ => _.currentLabel).join(", ");
      } else {
        this.displayText =
          this.curValue.length > 0 ? this.curValue.join(", ") : "-";
      }
    }
  }
}
